import React from 'react'

export default function NitrexLogo () {
  return <div>
    <a href="/" title="Document uploader">
      <img src="/logo.png" alt="Nitrex"/>
    </a>
  </div>
}
